import { Environment } from '../utils/Environment';

export const LOGIN_ROOT = `${Environment.getLoginUrl()}`;
export const API_ROOT = `${Environment.getApiUrl()}`;
export const DASHBOARD_API_ROOT = `${Environment.getDashboardApiUrl()}`;
export const ACCESSDETAILS_API_ROOT = `${Environment.getAccessDetailsApiUrl()}`;

// export const LOGIN_ROOT =`http://localhost:8000`;
// export const API_ROOT = `https://svwp-ctl-service-westus-dev-app-service-route.apps.np.stratus.albertsons.com`;
// export const DASHBOARD_API_ROOT = `https://svwp-dashboard-service-westus-dev-app-service-route.apps.np.stratus.albertsons.com`;

let locURL = (LOGIN_ROOT.includes(`dev`) || LOGIN_ROOT.includes(`localhost`)) ? `dev` : (LOGIN_ROOT.includes(`qa`) ? `qa` :
    (LOGIN_ROOT.includes(`perf`) ? `perf` : (LOGIN_ROOT.includes(`acceptance`) ? `perf` : (LOGIN_ROOT.includes(`stage`) ? `perf` : `prod`))));

export const apiUrl = {

    "testUrl": `https://jsonplaceholder.typicode.com/todos`,

}
export const getUserSFKeyMap = {
    url: `${API_ROOT}/closetheloop/getSalesForceIdEncryption`,
    method: `POST`
}
export const getUserSFKeyValidation = {
    url: `${API_ROOT}/closetheloop/getSalesForceIdEncryptionValidation`,
    method: `POST`
}
export const getAccessDetail = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getUserApplicationAccessDetails`,
    method: `POST`
}
export const getSubscriptionKey = {
    url: `${LOGIN_ROOT}/api/getSubKey`,
    method: `GET`
}
export const getDivision = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getDivisions`,
    method: 'GET'
}
export const getDistrict = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getDistrictByDivisionId/`,
    method: 'GET'
}
export const getDistrictByDivisionId = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getDistrictByDivisionId/`,
    method: 'GET'
}

export const getStore = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getStoreByDivisonId/`,
    method: 'GET'
}
export const getStoreByDistrict = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getStoreByDistrictId/`,
    method: 'GET'
}
export const getLocation = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getLocations/${locURL}`,
    method: 'GET'
}
export const getSearchResult = {
    url: `${API_ROOT}/ctl/archive`,
    method: 'GET'
}
export const getSearchResultArchive = {
    url: `${API_ROOT}/ctl/archive`,
    method: 'GET'

}
export const getSearchResultCurrent = {
    url: `${API_ROOT}/ctl/current`,
    method: 'GET'
}

export const exportToExcel = {
    url: `${API_ROOT}/ctl/current/exporttoexcel`,
    method: 'GET'
}

export const getTotalComments = {
    url: `${API_ROOT}/ctl/current/caseId`,
    method: 'GET'
}
export const getCaseIdForm = {
    url: `${API_ROOT}/ctl/current/caseId?contactId=`,
    method: 'GET'
}
export const getCaseIdFormArchive = {
    url: `${API_ROOT}/ctl/archive/cases/`,
    method: 'GET'
}
export const getRoleBasedDetails = {
    url: `${DASHBOARD_API_ROOT}/dashboard/getRoleBasedDetails`,
    method: 'GET'
}

export const closeContact = {
    url: `${API_ROOT}/ctl/close-caseid/`,
    method: 'POST'
}

export const saveNotClosed = {
    url: `${API_ROOT}/ctl/save-notclosed/`,
    method: 'POST'
}

export const contacts = {
    url: `${API_ROOT}/ctl/attempt/Contact`,
    method: 'GET'
}

export const positions = {
    url: `${API_ROOT}/ctl/attempt/Position`,
    method: 'GET'
}
